/* eslint-disable no-undef,no-param-reassign,import/named,consistent-return */
/**
 * Created by chengzhenfu on 2019/5/5.
 * Modified by  on .
 *axios 封装
 */
import baseURL from '@/configs/baseUrl'
import Axios from 'axios';
import router from '@/router/index';
import utils from '@/assets/jslibs/utils'
    const fetch = Axios.create({
        withCredentials: false,
        baseURL,
        timeout: 20000, // 设置超时时间
    });
    let time = null
    //请求发送前拦截，根据地址重新配置域名，再子路由请求时必须加/ 例如：请求 localhost:80/app/inset  fetch.get('/app/inset');
    fetch.interceptors.request.use(function (config) {
        if (!time) {
          time = setTimeout(() => {
            window.showLoading()
          }, 1000);
        }
        const token = utils.getCookie('X-Access-Token');
        //后期改成从cookies中获取
        config.headers = { 'X-Access-Token': token || sessionStorage.getItem('X-Access-Token') ||'' }
        return config;
    }, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    });

    // 添加响应拦截器
    fetch.interceptors.response.use(function (response) {
        window.hideLoading();
        if (time) {
          clearTimeout(time)
          time = null
        }
        return response;
    }, function (error) {
        // 对响应错误做点什么
        window.hideLoading();
        if (time) {
          clearTimeout(time)
          time = null
        }
        const { status, data } = error.response;
        switch (status) {
			case 401:
				if(sessionStorage.getItem("roleType") && sessionStorage.getItem("roleType")=="customer"){
					router.push('/login');
				}else{
					router.push('/account-login');
				}
				window.toast(data.error.message,"txt")
				break;
			case 403:
				if(data.error.message!="余额不足" && data.error.message!="登录出现问题咯"){
					window.toast(data.error.message,"txt")
				}
				return error.response
			case 412:
				break;
			
			case 500:
				window.toast("系统繁忙","txt");
				break;
			default:
				window.toast(data.error.message,"txt");
				return Promise.reject(data);
				break;
        }
    });

export default fetch;